import { Icon, InputGroup, InputRightElement } from '@everlywell/ui-kit';
import { MagnifyingGlass } from '@phosphor-icons/react';
import InputField from 'components/FormFields/InputField';
import React, { useState } from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { isValidZipCode } from 'utils/formHelpers';

export type ZipCodeInputFieldProps = {};

/**
 * [Zip Code Input Field for Quest Location Finder].
 */
const ZipCodeInputField = (props: ZipCodeInputFieldProps) => {
  const [hasInteracted, setHasInteracted] = useState(false);
  const handleFormInteraction = () => {
    if (!hasInteracted) {
      analytics.track({
        event: ANALYTICS.EVENTS.BEGIN_FORM_INTERACTION,
        data: {
          label: 'Quest Location Finder Zip Code Input',
        },
      });
      setHasInteracted(true);
    }
  };

  return (
    <InputGroup>
      <InputField
        name="zipCode"
        placeholder="Enter ZIP Code"
        label=""
        aria-label="ZIP Code"
        autoComplete="postal-code"
        inputMode="numeric"
        pattern="[0-9]*"
        onKeyDown={(event) => {
          if (
            !/[0-9]/.test(event.key) &&
            ![
              'Backspace',
              'ArrowLeft',
              'ArrowRight',
              'Delete',
              'Tab',
              'Enter',
            ].includes(event.key)
          ) {
            event.preventDefault();
          }
        }}
        onChange={handleFormInteraction}
        validations={{
          required: 'Please enter a valid ZIP Code',
          validate: {
            validZipCode: (value: string) => {
              if (!isValidZipCode(value)) {
                return 'Please enter a valid ZIP Code';
              }
            },
          },
        }}
      />
      <InputRightElement
        as="button"
        aria-label="Submit icon button"
        type="submit"
      >
        <Icon as={MagnifyingGlass} color={'tints.uiGrey'} />
      </InputRightElement>
    </InputGroup>
  );
};

export default ZipCodeInputField;
